export default "__VITE_ASSET__CynOGbY6__"